import React, { lazy } from 'react';
import styled from 'styled-components';

import {
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
} from '@mui/material';

import { eventUserStatuses } from 'lib/enums/eventUserStatuses';

export const SAccordion = styled(MuiAccordion)`
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
`;

export const SEventPreview = styled('div')`
  background-color: ${(props) =>
    props.isSelected
      ? props.status === eventUserStatuses.booked
        ? props.theme.palette.success.light
        : props.theme.palette.colors.yellow500
      : props.theme.palette.colors.white};
  border: 1px solid ${({theme}) => theme.palette.colors.gray200};
  border-radius: 18px;
  padding: 15px;
  box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
  margin: 0 10px 15px;

  &:hover {
    cursor: pointer;
  }
`;

export const SMuiAccordionSummary = styled(MuiAccordionSummary)`
  background: transparent !important;
`;
